export const familieopstellingReviews = [
  {
    id: 'review-kenneth',
    author: 'Kenneth Nelson',
    rating: 5,
    reviewBody: 'Het was een hele gezellige - leerzame en inzichtelijke dag met veel leuke en lieve mensen.',
    datePublished: '2025-06-15'
  },
  {
    id: 'review-marendsen',
    author: 'M Arendsen',
    rating: 5,
    reviewBody: 'Het was een bijzondere, liefdevolle en fijne middag. Marthe zet een veilige setting neer en begeleid met hart en ziel. Geeft alle ruimte die nodig is zodat er gezien kan worden, wat gezien "moet" worden.',
    datePublished: '2025-06-13'
  },
  {
    id: 'review-wieke',
    author: 'Wieke',
    rating: 5,
    reviewBody: 'Het was mijn eerste ervaring met een opstellingenavond en ik had het denk ik niet beter kunnen treffen. Ik voelde me zeer welkom en meegenomen in het proces. Overall een heel prettige ervaring in een fijne en veilige omgeving.',
    datePublished: '2025-01-16'
  }
];

